import { Container, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import * as SiteFileQL from "queries/site-file";
import SiteFileSchema from "@common/schema/site-file/public";
import { KIND_CONFIG } from "@common/schema/site-file/kind";
import * as widgets from "widgets/register";
import * as Section from "@repoflow/components/section";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params, params: { kind } } }) => {
  const { base } = Section.useSectionContext();

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
      </Row>

      <div className="mt-4"></div>

      <List
        path={"viewer.account.sites.get.files"}
        query={SiteFileQL.list}
        variables={params}
        schema={SiteFileSchema}
        widgets={widgets}
        target={{ $ref: "/Public/SiteFile" }}
        // Named for the kind rather than "No files yet", so the two tabs do not
        // both answer with the same sentence and leave you unsure which one you
        // are looking at.
        empty={`No ${KIND_CONFIG[kind].label.toLowerCase()} yet.`}
        config={{
          // `status` earns its place here and nowhere else in the app: a file
          // is created before its bytes are uploaded and stays "processing"
          // until bucketws' handler has seen the S3 event, so a row that is not
          // yet usable has to say so on the listing rather than only on the
          // screen you would have to open to find out.
          //
          // Not `metadata`, `hash` or `bucketId` — a listing is not where those
          // are read, and the first is unbounded.
          "/Public/SiteFile": {
            fields: ["name", "ext", "size", "status", "createdAt"],
          },
        }}
        content={({ item: { fileId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${fileId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />
    </Container>
  );
};
